import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { css } from "styled-components";

export const filterRowDisplayStyles = css`
  display: flex;
  align-items: end;
  ${responsiveMediaQueries.tabletAndBelow} {
    align-items: center;
  }
  ${responsiveMediaQueries.mobile} {
    align-items: flex-start;
  }
`;
